import axios from 'axios';
import get from 'lodash/get';
import { SHOW_SNACK_BAR } from '../globalActions';

export const GET_TEACHER_LISTINGS_LOADING = 'GET_TEACHER_LISTINGS_LOADING';
export const GET_TEACHER_LISTINGS_SUCCESS = 'GET_TEACHER_LISTINGS_SUCCESS';
export const GET_TEACHER_LISTINGS_ERROR = 'GET_TEACHER_LISTINGS_ERROR';

export const GET_TEACHER_LISTING_LOADING = 'GET_TEACHER_LISTING_LOADING';
export const GET_TEACHER_LISTING_SUCCESS = 'GET_TEACHER_LISTING_SUCCESS';
export const GET_TEACHER_LISTING_ERROR = 'GET_TEACHER_LISTING_ERROR';

export const UPDATE_TEACHER_LISTING_LOADING = 'UPDATE_TEACHER_LISTING_LOADING';
export const UPDATE_TEACHER_LISTING_SUCCESS = 'UPDATE_TEACHER_LISTING_SUCCESS';
export const UPDATE_TEACHER_LISTING_ERROR = 'UPDATE_TEACHER_LISTING_ERROR';

export const CREATE_TEACHER_LISTING_LOADING = 'CREATE_TEACHER_LISTING_LOADING';
export const CREATE_TEACHER_LISTING_SUCCESS = 'CREATE_TEACHER_LISTING_SUCCESS';
export const CREATE_TEACHER_LISTING_ERROR = 'CREATE_TEACHER_LISTING_ERROR';

export function fetchTeacherListings(success, failure) {
  return (dispatch, getState) => {
    const state = getState();

    dispatch({ type: GET_TEACHER_LISTINGS_LOADING });

    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/teacher/listing`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.user.token}`
        }
      })
      .then(response => {
        dispatch({
          type: GET_TEACHER_LISTINGS_SUCCESS,
          payload: response.data.data
        });
        success && success();
      })
      .catch(error => {
        if (process.env.NODE_ENV !== 'production') {
          console.log('catch', error);
        }

        let response = get(error, 'response.data');
        if (!response) {
          response = { _error: 'Network Error' };
        }

        dispatch({
          type: GET_TEACHER_LISTINGS_ERROR,
          payload: response
        });
        failure && failure(response);
      });
  };
}

export function fetchTeacherListing(listingId, success, failure) {
  return (dispatch, getState) => {
    const state = getState();

    dispatch({ type: GET_TEACHER_LISTING_LOADING });

    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/teacher/listing/${listingId}`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.user.token}`
        }
      })
      .then(response => {
        dispatch({
          type: GET_TEACHER_LISTING_SUCCESS,
          payload: response.data.data
        });
        success && success();
      })
      .catch(error => {
        if (process.env.NODE_ENV !== 'production') {
          console.log('catch', error);
        }

        let response = get(error, 'response.data');
        if (!response) {
          response = { _error: 'Network Error' };
        }

        dispatch({
          type: GET_TEACHER_LISTING_ERROR,
          payload: response
        });
        failure && failure(response);
      });
  };
}

export function updateTeacherListing(listingId, data, success, failure) {
  return (dispatch, getState) => {
    const state = getState();

    dispatch({ type: UPDATE_TEACHER_LISTING_LOADING });

    axios
      .put(`${process.env.REACT_APP_BACKEND_URL}/teacher/listing/${listingId}`, data, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.user.token}`
        }
      })
      .then(response => {
        dispatch({
          type: UPDATE_TEACHER_LISTING_SUCCESS,
          payload: response.data.data.listing
        });
        // TODO: not sure if this is the best thing to do but this architecture
        // feels limiting ...all I'm trying to do is update two objects here
        dispatch({
          type: 'REFRESH_USER_SUCCESS',
          payload: response.data.data
        });
        dispatch({ type: SHOW_SNACK_BAR });
        success && success();
      })
      .catch(error => {
        if (process.env.NODE_ENV !== 'production') {
          console.log('catch', error);
        }

        let response = get(error, 'response.data');
        if (!response) {
          response = { _error: 'Network Error' };
        }

        dispatch({
          type: UPDATE_TEACHER_LISTING_ERROR,
          payload: response
        });
        failure && failure(response);
      });
  };
}

export function createTeacherListing(data, success, failure) {
  return (dispatch, getState) => {
    const state = getState();

    dispatch({ type: CREATE_TEACHER_LISTING_LOADING });

    axios
      .post(`${process.env.REACT_APP_BACKEND_URL}/teacher/listing/`, data, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.user.token}`
        }
      })
      .then(response => {
        dispatch({
          type: CREATE_TEACHER_LISTING_SUCCESS,
          payload: response.data.data.listing
        });
        // TODO: not sure if this is the best thing to do but this architecture
        // feels limiting ...all I'm trying to do is update two objects here
        dispatch({
          type: 'REFRESH_USER_SUCCESS',
          payload: response.data.data
        });
        success && success();
      })
      .catch(error => {
        if (process.env.NODE_ENV !== 'production') {
          console.log('catch', error);
        }

        let response = get(error, 'response.data');
        if (!response) {
          response = { _error: 'Network Error' };
        }

        dispatch({
          type: CREATE_TEACHER_LISTING_ERROR,
          payload: response
        });
        failure && failure(response);
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/Teacher/listingActions.js